import { useSelector } from 'react-redux';

// Active organization's ISO-4217 currency (single currency per org — no FX conversion).
//
// Sourced from the ActiveContext redux slice, which the backend keeps current on login,
// /auth/me, context switch, and the active-context refresh. Reading the slice (rather than
// localStorage directly) makes consumers reactive: when the active-context refresh lands the
// currency mid-session, the component re-renders with it — no page reload needed.
//
// Falls back to localStorage for the first paint before the slice hydrates, then to the
// embedded organization.currency (single-org users), and finally USD as a last resort.
// Returns null currency consumers should treat via formatCurrency's own USD default.
export default function useOrgCurrency() {
  const fromSlice = useSelector((s) => s.ActiveContext?.activeOrganizationCurrency);
  if (fromSlice) return fromSlice;
  try {
    const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
    return authUser?.activeOrganizationCurrency || authUser?.organization?.currency || 'USD';
  } catch {
    return 'USD';
  }
}
